import withIsFeatureActive from "web/core/UNSAFE_featureFlags/withIsFeatureActive";

const withIsInStockAlertEnabled = () =>
  withIsFeatureActive("inStockAlert", "inStockAlert");

export default withIsInStockAlertEnabled;
